import { render, staticRenderFns } from "./Comfirm.vue?vue&type=template&id=27204a19&scoped=true&"
import script from "./Comfirm.vue?vue&type=script&lang=js&"
export * from "./Comfirm.vue?vue&type=script&lang=js&"
import style0 from "./Comfirm.vue?vue&type=style&index=0&id=27204a19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27204a19",
  null
  
)

export default component.exports